import React from "react";
import {
  TableCell
} from "@mui/material";
import {
  makeStyles
} from "@mui/styles";
import {
  ArrowDropUp as ArrowDropUpIcon,
  ArrowDropDown as ArrowDropDownIcon
} from "@mui/icons-material";
import clsx from "clsx";

const TableCeilSort = ({ children, name, sort_field, sort_direction, sx, onChange }) => {
  const classes = useStyles();
  const isActive = Boolean(String(sort_field || '').includes(String(name || '')));

  const handleClick = () => {
    if (!isActive) {
      onChange({sort_field: name, sort_direction: 'asc'});
      return
    }
    if (isActive && sort_direction === 'asc') {
      onChange({sort_field: name, sort_direction: 'desc'});
      return
    }
    onChange({sort_field: name, sort_direction: 'asc'});
  }

  return (
    <TableCell
      sx={sx}
      className={clsx({
        [classes.tableCell]: true,
        [classes.tableCellActive]: isActive,
      })}
      onClick={handleClick}
    >
      <div>
        <span>{children}</span>
        <span className={classes.tableCellIcon}>
          <div>
            <ArrowDropUpIcon color={Boolean(isActive && sort_direction === 'asc') ? 'primary' : 'secondary'} />
          </div>
          <div>
            <ArrowDropDownIcon color={Boolean(isActive && sort_direction === 'desc') ? 'primary' : 'secondary'} />
          </div>
        </span>
      </div>
    </TableCell>
  )
}

const useStyles = makeStyles((theme) => ({
  tableCell: {
    cursor: "pointer",
    "& > div": {
      display: "flex",
      alignItems: "center",
    },
    "&:hover": {
      color: "#635EF2"
    }
  },
  tableCellActive: {
    color: "#635EF2"
  },
  tableCellIcon: {
    marginLeft: "8px",
    flexDirection: "column",
    "& div": {
      width: 8, height: 8,
      minHeight: 8,
      position: "relative",
    },
    "& .MuiSvgIcon-root": {
      position: "absolute",
      top: "50%", left: "50%",
      transform: "translate(-50%, -50%)",
    }
  }
}));

export default TableCeilSort
